<script setup>
import i18n from './CvPrintHistoryEntry.i18n.js';

defineProps({
    entry: {
        type: Object,
        required: true,
    },
    isJobExperience: {
        type: Boolean,
        default: false,
    },
});
function formatPeriodDate(datestr) {
    if (!datestr) {
        return '';
    }
    if (/^\d{4}-\d{2}(-\d{2})?$/.test(datestr)) {
        const options = { year: 'numeric', month: 'short' };
        const formatted = new Date(datestr).toLocaleDateString(document.documentElement.lang, options);
        return formatted.replace(/\s+/g, '\u00a0'); // Insert non-breaking space
    }
    return datestr;
}
function formatPeriod(start, end) {
    let startDate = formatPeriodDate(start);
    let endDate = formatPeriodDate(end);

    if (startDate === endDate) {
        return startDate || '–';
    }

    endDate = endDate || '(' + i18n.now() + ')';
    return `${startDate} – ${endDate}`;
}
function formatDuration(start, end) {
    if (!start || !end) {
        return '';
    }
    if (/^\d{4}-\d{2}(-\d{2})?$/.test(start) && /^\d{4}-\d{2}(-\d{2})?$/.test(end)) {
        const [startyear, startmonth] = start.split("-");
        const [endyear, endmonth] = end.split("-");

        let years = endyear - startyear;
        let months = endmonth - startmonth;
        if (months < 0) {
            months += 12;
            years -= 1;
        }

        const parts = [];
        if (years > 0) {
            parts.push(i18n.durationYears(years));
        }
        if (months > 0) {
            parts.push(i18n.durationMonths(months));
        }

        return parts.length > 0 ? '(' + parts.join(', ') + ')' : '';
    } else if (!/^\d{4}-\d{2}(-\d{2})?$/.test(start) && !/^\d{4}-\d{2}(-\d{2})?$/.test(end)) {
        return '(' + i18n.durationYears(end - start) + ')';
    } else {
        return '';
    }
}
</script>

<template>
    <div class="cv-print-history-entry" role="listitem">
        <div style="break-inside: avoid-page;">
            <h3 class="h5 mb-0">
                {{ entry.name }}
                <small v-if="entry.managementPosition" class="text-muted ml-1">({{ i18n.managementPosition() }})</small>
            </h3>
            <div class="row mt-1" v-if="entry.place || entry.company || entry.start || entry.end">
                <div class="col-auto cv-print-history-entry__place" :class="{ 'border-right': entry.start || entry.end }" v-if="entry.place || entry.company">
                    {{ entry.place || entry.company }}
                </div>
                <div class="col cv-print-history-entry__date" v-if="entry.start || entry.end">
                    {{ formatPeriod(entry.start, entry.end) }}
                    <span class="ml-1" v-if="isJobExperience">{{ formatDuration(entry.start, entry.end) }}</span>
                </div>
            </div>
        </div>
        <div
            class="mb-0 mt-1"
            style="break-before: avoid-page;"
            v-if="entry.remarkHtml"
            v-html="entry.remarkHtml"
        />
    </div>
</template>
